module.exports = __webpack_public_path__ + "img/e3c0f27.png";